// 폰트 vuex
const fontStore = {
  namespaced: true,

  state: {
    notice: 0,
    request: 0,
    incongruity: 0,
    voc: 0,
    reminder: 0
  },

  getters: {
    getNoticeFontSize: state => state.notice,
    getRequestFontSize: state => state.request,
    getIncongruityFontSize: state => state.incongruity,
    getVOCFontSize: state => state.voc,
    getReminderFontSize: state => state.reminder
  },

  mutations: {
    // mutationNoticeFontSize: (state, payload) => {
    //   if (payload < 0) {
    //       state.notice = 0
    //   } else {
    //       state.notice = payload
    //   }
    // },

    mutationNoticeFontSize: (state, payload) => {
      // payload는 "최종 폰트 크기(px)"로 들어온다고 가정
      if (!payload || payload < 13) {
        state.notice = 13
      } else {
        state.notice = payload
      }
    },

    mutationRequestFontSize: (state, payload) => {
      if (payload < 0) {
        state.request = 0
      } else {
        state.request = payload
      }
    },

    mutationIncongrutiryFontSize: (state, payload) => {
      if (payload < 0) {
        state.incongruity = 0
      } else {
        state.incongruity = payload
      }
    },

    mutationVOCFontSize: (state, payload) => {
      if (payload < 0) {
        state.voc = 0
      } else {
        state.voc = payload
      }
    },

    mutationReminderFontSize: (state, payload) => {
      if (payload < 0) {
        state.reminder = 0
      } else {
        state.reminder = payload
      }
    },
  }
}

export default fontStore
